import * as _ from 'lodash';
import { BehaviorSubject, Observable, ReplaySubject, Subject } from 'rxjs';
import { map } from 'rxjs/operators';
import { Injectable } from '@angular/core';

import { Brand } from 'models';
import { Page } from '../../components/abstract-paged-component/abstract-page-component';
import { ITEMS_PER_PAGE_CONTENT } from './constants';
import { ProductService } from 'app/content/services/product.service';
import { UserService, Plan } from 'app/shared/services';

@Injectable({
    providedIn: 'root'
})
export class ContentService {
    private displayMode: Subject<DisplayMode> = new ReplaySubject();
    private liteBannerVisible: Subject<boolean> = new ReplaySubject();
    private downloadListToggle: Subject<void> = new ReplaySubject();
    private showSummaryBar: Subject<boolean> = new BehaviorSubject(false);
    private pageInfo: Subject<Page> = new BehaviorSubject<Page>({
        page: 1,
        pageSize: ITEMS_PER_PAGE_CONTENT,
        dataSetEnd: ITEMS_PER_PAGE_CONTENT,
        dataSetStart: 0
    });

    constructor(
        private userService: UserService,
        private productService: ProductService
    ) {}

    getPvhBrand(brandId: string): Observable<string> {
        return this.productService.getPvhAllowedBrands().pipe(
            map((allowedBrands) => {
                if (allowedBrands.includes(brandId)) {
                    return brandId;
                }
            })
        );
    }

    getDisplayMode() {
        return this.displayMode.asObservable();
    }

    setDisplayMode(width: number) {
        if (width < 1280) this.displayMode.next(DisplayMode.Mobile);
        else this.displayMode.next(DisplayMode.Desktop);
    }

    getDownloadListToggle() {
        return this.downloadListToggle.asObservable();
    }

    toggleDownloadList() {
        this.downloadListToggle.next();
    }

    setPageInfo(pageInfo: Page): void {
        this.pageInfo.next(pageInfo);
    }

    getPageInfo(): Subject<Page> {
        return this.pageInfo;
    }

    showLiteBanner(brand: Brand) {
        const isPremiumRetailer = this.userService.getPlan() === Plan.Premium;
        const isPremiumBrand = brand.isPremium;

        this.liteBannerVisible.next(!isPremiumRetailer && !isPremiumBrand);
    }

    setLiteBannerVisibility(visible: boolean) {
        this.liteBannerVisible.next(visible);
    }

    getLiteBannerVisibility() {
        return this.liteBannerVisible.asObservable();
    }

    setShowSummaryBar(show: boolean) {
        this.showSummaryBar.next(show);
    }

    getShowSummaryBar() {
        return this.showSummaryBar.asObservable();
    }
}

export enum DisplayMode {
    Desktop = 'desktop',
    Mobile = 'mobile'
}
